import { createApi } from '@reduxjs/toolkit/query/react';
import   {appBaseQuery} from "../services/baseQuery"


export const mealSliceApi = createApi({
  reducerPath: 'mealSliceApi',
     baseQuery:appBaseQuery,

  tagTypes: ['Meals'],
  endpoints: (builder) => ({
    // GET meals 
    getMeals: builder.query({
      query: ({ page = 1, limit = 10 }) =>
        `meals/?page=${page}&limit=${limit}`,
      providesTags: ['Meals'],
    }),

    // POST (add new meal )
    addMeals: builder.mutation({
      query: (newItem) => ({
        url: 'meals/',
        method: 'POST',
        body: newItem,
      }),
      invalidatesTags: ['Meals'],
    }),

    // PUT (update meals)
    updateMeals: builder.mutation({
      query: ({ id, ...updatedData }) => ({
        url: `meals/${id}/`,
        method: 'PUT',
        body: updatedData,
      }),
      invalidatesTags: ['Meals'],
    }),

    // DELETE meals
    deleteMeals: builder.mutation({
      query: (id) => ({
        url: `meals/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Meals'],
    }),
  }),
});

export const {
  useGetMealsQuery,
  useAddMealsMutation,
  useUpdateMealsMutation,
  useDeleteMealsMutation,
} = mealSliceApi;
